import ExclamationMarkIcon from '@/assets/icons/ic_logic-g-app_exclamation-mark.svg'

import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  onRequestClose: () => void
}

export const PlayerRegistrationWarningModal = ({
  isOpen,
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      showCloseButton={true}
      customStyles={{
        content: {
          textAlign: 'center',
          backgroundColor: '#F5F7FC',
          boxShadow: '0px 2px 2px 0px #00000040',
          width: 'auto',
        },
      }}
      {...rest}
      onRequestClose={onRequestClose}
      className="delete-user-modal"
    >
      <div className="w-[335px] p-[35px_28px_30px] md:w-[512px] md:p-[40px_31px_30px]">
        <h3 className="mb-[16px] text-lg text-[#222222] md:mb-[28px] md:text-2xl">
          プレイヤーを登録してください
        </h3>

        <p className="text-xs leading-normal tracking-widest text-[#222222] md:text-[15px]">
          申し込みの前に、プレイヤーの登録をお願いします。
        </p>

        <div className="mx-auto mt-[16px] flex h-[104px] w-[104px] items-center justify-center rounded-full bg-primary-20 md:mt-[40px]">
          <ExclamationMarkIcon width={82} />
        </div>

        <Button
          variant="secondary"
          className="mx-auto mt-[16px] w-[270px] text-[#222222] md:mt-[40px]"
          onClick={onRequestClose}
        >
          閉じる
        </Button>
      </div>
    </Modal>
  )
}
